import React from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";

SwiperCore.use([Pagination, Navigation, Autoplay]);

const Slider = ({
  Item,
  list,
  space,
  perView,
  perGroup = 1,
  center,
  wrapperClass,
  slideClass,
  breakpoints,
  navigation = true,
  pagination = false,
  autoplay = false,
  loop,
  ...rest
}) => {
  return (
    <Swiper
      className={wrapperClass}
      spaceBetween={space}
      slidesPerView={perView}
      slidesPerGroup={perGroup}
      centeredSlides={center}
      breakpoints={breakpoints}
      navigation={navigation}
      pagination={pagination}
      autoplay={autoplay}
      loop={loop}
    >
      {list.map((item, i) => (
        <SwiperSlide className={slideClass} key={i}>
          <Item key={i} data={item} {...rest} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Slider;
